import {Model} from "@/services/api";

export default class Page extends Model {
    static route() {
        return 'pages';
    }
}
